<template>
  <div @click.capture="checkLoginGbn">
    <header :id="popup ? 'header-pop' : 'header'" :class="[{mainHeader : main},{move : move}]">
        <div>
            <h1 v-html="pageName" @click="refresh"></h1>
            <!-- 팝업 -->
            <template v-if="popup">
                <button type="button" class="prev allow-click" v-show="prevBtnShow" @click="onPrev">이전</button>
                <button type="button" class="close" @click="close">닫기</button>
            </template>
            <!-- 페이지 -->
            <template v-else>
                <span><a href="https://waple.kyowon.co.kr/chatbot" v-if="userId === '1640371'" style="color: red;">INFO</a></span>
                <button type="button" class="prev allow-click" v-show="prevBtnShow" @click="onPrev">이전</button>
                <!-- <button type="button" class="survey" v-if="srvySqno" @click="openSurv">설문</button>  -->
                <button type="button" class="survey" v-if="srvySqno&&main" @click="openSurv">설문</button>
                <button type="button" class="alarm" :class="{ on: alarm }" @click="moveRouter('notification')">알림</button>
                <button type="button" class="menu allow-click" @click="slideMenu">메뉴</button>

            </template>
        </div>

        <nav :class="{ slide : slideActive }">
            <div>
                <a href="/" class="home">홈</a>
                <a class="logout allow-click" @click="logout">로그아웃</a>

                <p>
                    <strong v-text="userName"></strong>
                    <span v-text="orgnzPstnNm+'님'"></span>
                </p>
                <button type="button" class="qr" @click="moveRouter('edu-kakao-sync')">QR인증</button>
                <button type="button" class="slide-close allow-click" @click="slideMenu">닫기</button>
            </div>
            <ul>
                <li><a href="/myCstmr/myCstmrList">내 고객보기</a></li>
                <li
                    v-if="$store.getters.orgnzPstn == 'COG01' || $store.getters.orgnzPstn == 'COG02'">
                        <a href="/orgStatus/orgStatusList">조직현황보기</a>
                </li>
                <li>
                    <a href="/eduplanmap">에듀플랜맵</a>
                    <ul>
                        <li><a href="#none">상품별 플랜</a></li>
                        <li><a href="#none">나만의 플랜</a></li>
                    </ul>
                </li>
                <li><a href="/mySchedule/myScheduleList">내 일정보기</a></li>
                <!-- <li>
                    <a href="javascript:void(0)" @click="dropMenu(2)" :class="{ current: isDropMenu == 2 }">내 일정보기</a>
                    <ul>
                        <li><a href="/mySchedule/myScheduleList">내 일정</a></li>
                        <li><a href="/mySchedule/hdSchedule">본사 일정</a></li>
                    </ul>
                </li> -->
                <li>
                    <a href="javascript:void(0)" @click="dropMenu(3)" :class="{ current: isDropMenu == 3 }">마이페이지</a>
                    <ul>
                        <li><a href="/mypage/bsnPlnList">영업활동계획</a></li>
                        <li><a href="/mypage/report">활동리포트</a></li>
                        <li><a href="/mypage/myEduInfor">내 활동 정보</a></li>
                        <li><a href="/mypage/surveyList">참여 설문</a></li>
                        <li><a  @click="moveRouter('edu-qr-atnd-list')">교육출결</a></li>
                    </ul>
                </li>
                <!-- <li><a @click="moveRouter('edu-qr-atnd-list')">교육 출결 관리</a></li> -->
                <li><a class="allow-click" href="/notice">공지사항</a></li>
                <li><a href="/faq">FAQ</a></li>
                <!--<li><a @click="openQrScaner()">QR교육출결</a></li>-->
                <li>
                    <a href="javascript:void(0)" @click="dropMenu(4)" :class="{ current: isDropMenu == 4 }">설정</a>
                    <ul>
                        <li><a @click="onNewPage('/set/notificationSet')">설정</a></li>
                        <li><a @click="onNewPage('/set/dashboardSet')">홈 편집</a></li>
                        <li><a @click="onNewPage('/set/myCstmrRegSet')">고객등록 편집</a></li>
                        <li><a href="/set/tutorial">튜토리얼</a></li>
                    </ul>
                </li>
            </ul>
        </nav>
    </header>
  </div>
</template>

<script>
// import axios from 'axios'
import store from '@/store/store'
export default {
    props: {
        header: Boolean,
        pageName : String,
        popup : Boolean,
        main : Boolean,
        prevBtnShow : Boolean,
        alarm : Boolean,
        reload: Boolean,
        history: {
            type: String,
            require: false,
            default: null
        },
        bfClose: Boolean,
        srvySqno: String,
    },
    data() {
      return {
        slideActive : false,
        isDropMenu : 0,
        userName: this.$utils.ui.getUserName(), // 이름
        orgnzPstnNm: this.$utils.ui.getOrgnzPstnNm(), // 직급,
        userId : this.$store.getters.userId,  //로그인사번
        loginGbn : this.$store.getters.loginGbn, //로그인구분
        move : false,
      };
    },
    watch: {
        '$store.state.ui.child': function() {
          console.log("★여기는 베이스 헤더! 내가 먼저 바꾼다!");
            var childName = this.$store.state.ui.child.name;
            if(childName == 'popup-close') {
                var data = this.$store.state.ui.child.data;
                var routerName = data.routerName;
                if(this.$router.currentRoute.name == routerName) {
                    this.$router.go(this.$router.currentRoute)
                } else {
                    this.$router.push({name: data.routerName}).catch(function () {});
                }
            }
        }
    },
    created () {
        window.addEventListener('scroll', this.moveScroll);
        // this.chkWorkNotice();
    },
    updated: function() {
        // this.chkWorkNotice();
    },
    destroyed () {
        window.removeEventListener('scroll', this.moveScroll);
    },
    methods: {
        moveScroll () {
            this.isUserScrolling = (window.scrollY > 0);
            if(this.isUserScrolling){
                this.move = true
            }else{
                this.move = false
            }
        },
        slideMenu : function(){
            this.slideActive = !this.slideActive;
        },
        dropMenu: function(el){

            if(this.isDropMenu == el){
                this.isDropMenu = 0;
            }else{
                this.isDropMenu = el;
            }
        },
        onPrev: function() {
            if(this.history == null){
                console.log('BaseHeader.vue', 'onPrev', this.$router);
                this.$router.back();
            }else{
                this.$router.push({ name: this.history }).catch(function() {});
            }
        },
        logout() {
            console.log('BaseHeader.vue', 'logout');
            this.$store.dispatch("clearUser");
            this.$utils.nativeIf.outbound.sessionExpired();
        },
        close() {
            if(this.bfClose){
                this.$emit('beforeClose');
            }
            if(this.history != null) {
                var child = {
                    name: 'popup-close',
                    data: {
                        routerName : this.history,
                    }
                }
                this.$utils.nativeIf.outbound.sendChildData(child);
            } else {
                this.$utils.nativeIf.outbound.close(this.reload);
            }
        },
        onNewPage: function(url) {
            this.$utils.nativeIf.outbound.newPage(url);
        },
        openSurv : function(){
            // this.$router.push('/mypage/SurveyView?srvySqno='+this.srvySqno);  // 현재창 에서 넘어가기
            // this.$utils.nativeIf.outbound.newPage("/mypage/SurveyView?srvySqno="+this.srvySqno+"&from=main")  //새창 띄우기
            this.$router.push({ name: "survey-view", query: { srvySqno: this.srvySqno}}).catch(function() {});
        },
        refresh: function(){
            if(this.main){   //메인일때만 새로고침.
                this.$router.go(0)
            }
        },
        moveRouter: function(routerName) {
            if(this.$router.currentRoute.name === routerName) {
                this.$router.go(this.$router.currentRoute)
            } else {
                this.$router.replace({ name: routerName }).catch(function() {});
            }
        },
        checkLoginGbn(event) {
        if (this.loginGbn === 'IS') {
            // 1. 허용된 클릭인지 확인 (.allow-click)
            const isAllowed = event.target.closest('.allow-click');
            if (isAllowed) return; // 허용된 요소면 통과 (정상 @click 실행)

            // 2. 실제로 "클릭 가능한 요소(버튼, a태그, strong태그 등)"를 누른 건지 확인
            // alert이 떠야 하는 대상을 closest()로 지정합니다.
            const isClickableableElement = event.target.closest('button, a, strong, .btn, [role="button"]');

            // 클릭 가능한 요소를 눌렀을 때만 차단 및 alert 띄움
            if (isClickableableElement) {
              event.preventDefault(); //href 차단
              event.stopPropagation(); // 자식 @click 차단
              alert('해당기능은 추후 업데이트 예정입니다.');
            }
        }
      },
    },
    mounted: function() { //  인스턴스가 마운트 된
       var loginGbn = store.getters.loginGbn;  //AK(지국장, EP선생님), IS(본사직원(지금 육성지원팀만))
       console.log("******************loginGbn>>>>>>>>>>>"+loginGbn);
    }

};
</script>
